import { InstallationWithResources } from '@/features/installations/api/InstallationModel'
import { createContext, useContext } from 'react'

type AppStateContextProps = {
  installations: InstallationWithResources[]
  selectedInstallationId: string | null
  setSelectedInstallationId: (installationId: string) => void
}

export const AppStateContext = createContext<AppStateContextProps>({
  installations: [],
  selectedInstallationId: null,
  setSelectedInstallationId: () => {}
})

export const useAppState = () => {
  const context = useContext(AppStateContext)

  if (!context) {
    throw new Error('useAppState must be used within a AppStateProvider')
  }

  const installationsById = Object.fromEntries(
    context.installations.map(installation => [installation.id, installation])
  )

  return {
    ...context,
    installationsById
  }
}
